import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { AuthContext } from "../../../../Header/auth - context";
import { useSelector } from 'react-redux';
import usePermission from '../../../../custom/usePermission';
import { FileUpload } from 'primereact/fileupload';
import { Toast } from "primereact/toast";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { AutoComplete } from "primereact/autocomplete";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; 
import { InputTextarea } from 'primereact/inputtextarea';
import CustomDropdown from '../../../../custom/customDropdown';

const KlijentiUnos = (props) => {
  const { t } = useTranslation();

    const auth = useContext(AuthContext);
    const formRef = useRef(null);
    const toast = useRef(null);
    const company = useSelector(state => state.company)
    const user = useSelector(state => state.user)
    const eskaliran = useSelector(state => state.eskaliran)
    const role_id = useSelector(state => state.user_role)
    const { can } = usePermission();
    const [idClient, setIdClient] = useState(null)
    const [idForFiles, setIdForFiles] = useState(null)
    const [clientsDB, setClientsDB] = useState(null)
    const [filteredClients, setfilteredClients] = useState([]);
    const [izabran, setIzabran] = useState(false)
    const [popuni, setPopuni] = useState(false)
    const [nbsPoruka, setNBSPoruka] = useState(false)
    const [pibNBS, setPIBNbs] = useState(null)
    const [statusPreduzecaOptions, setStatusPreduzecaOptions] = useState(null)
    const [tipoviPreduzecaOptions, setTipoviPreduzecaOptions] = useState(null)
    const [statusRacunaOptions, setStatusRacunaOptions] = useState(null)
    const [tipoviRacunaOptions, setTipoviRacunaOptions] = useState(null)
    const [drzaveOptions, setDrzaveOptions] = useState(null)
    const [formSubmitted, setFormSubmitted] = useState(false);
    const classDocumentDB = 'btnHasDocument';
    const [buttonDocumentDB, setButtonDocumentDB] = useState({
        uploadedFileGeneral: 0,    // FileUpload
        uploadedFileAPR: 0
        })
  
    const [direktori, setDirektori] = useState([]);

        const [saradnici, setSaradnici] = useState([]);

        const [racuni, setRacuni] = useState([]);
   
         const handleRacunChange = (index, field, value) => {
        const updated = [...racuni];
        updated[index][field] = value;
        setRacuni(updated);
        };

        const addRacun = () => {
        setRacuni([...racuni, { tekuciRacun: '', swift: '', nazivBanke: '', statusRacuna: null, tipRacuna:null }]);
        };

        const removeRacun = (index) => {
        setRacuni(racuni.filter((_, i) => i !== index));
        };

        const handleDirektorChange = (index, field, value) => {
        const updated = [...direktori];
        updated[index][field] = value;
        setDirektori(updated);
        };

        const addDirektor = () => {
        setDirektori([...direktori, { direktorImePrezime: '', direktorEmail: '', direktorMobilni: '' }]);
        };

        const removeDirektor = (index) => {
        setDirektori(direktori.filter((_, i) => i !== index));
        };

        // Saradnici
        const handleSaradnikChange = (index, field, value) => {
        const updated = [...saradnici];
        updated[index][field] = value;
        setSaradnici(updated);
        };

        const addSaradnik = () => {
        setSaradnici([...saradnici, { saradnikImePrezime: '', saradnikEmail: '', saradnikMobilni: '', saradnikFunkcija: '' }]);
        };

        const removeSaradnik = (index) => {
        setSaradnici(saradnici.filter((_, i) => i !== index));
        };

    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };
  
const booleanOptions = [{value:true, label:"DA"},{value:false, label:"NE"}]

///DATA
const [formDataCompanyGeneral, setFormDataCompanyGeneral] = useState({
  nazivFirme: '',
  pib: '',
  maticniBroj: '',
  adresa: '',
  adresaPoste: '',
  grad: '',
  postanskiBroj: '',
  id_drzava: null,
  telefon: '',
  fiksni: '',
  emailAdresa: '',
  vebStranica: '',
  tipPreduzeca: '',
  statusPreduzeca: '',
  crnaLista: null,
  poreskiObveznik: null,
  pdvObveznik: null,
  automatskaBlokada: null,
  valuta: null,
  budzet: '',
  napomenaBudzet: '',
  napomena: '',
  dodatnaNapomena: '',
  ugovorenaPravilaNapomena: ''
});

///FILES
    const [formDataCompanyGeneralFILES, setFormDataCompanyGeneralFILES] = useState({
        uploadedFileGeneral: [],    // FileUpload
        uploadedFileAPR: null
    });

    const searchClients = (event) => {
        if(clientsDB) {
              let query = event.query;

                let _filteredClients = [];
                let filteredItems = clientsDB.filter(
                (item) => item.Naziv.toLowerCase().indexOf(query.toLowerCase()) !== -1
                );
                if (filteredItems && filteredItems.length) {
                _filteredClients.push(...filteredItems);
                }

                setfilteredClients(_filteredClients);
                    }
  
  };


    useEffect(()=>{
         let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                        };
                        fetch(process.env.REACT_APP_BACKEND_URL + "/clients", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                                setClientsDB(parsedData.ClientsDB)
                                setStatusPreduzecaOptions(parsedData.StatusiPreduzeca)
                                setTipoviPreduzecaOptions(parsedData.TipoviPreduzeca)
                                setStatusRacunaOptions(parsedData.StatusiRacuna)
                                setTipoviRacunaOptions(parsedData.TipoviRacuna)
                                setDrzaveOptions(parsedData.DrzaveDB)

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
    },[formSubmitted])

    const handleChangeDocUpload = (name, files) => {
   
        
        if (name === 'uploadedFileGeneral') {
            if (files) {
                // Ako je files niz, dodajemo sve fajlove, ako je jedan fajl, pravimo niz od njega
                const filesArray = Array.isArray(files) ? files : [files];
                setFormDataCompanyGeneralFILES(prev => ({ 
                    ...prev, 
                    [name]: [...prev[name], ...filesArray] 
                }));
            } else {
                // Ako je files null, resetujemo vrednost
                setFormDataCompanyGeneralFILES(prev => ({ ...prev, [name]: [] }));
            }
        } else {
            setFormDataCompanyGeneralFILES(prev => ({ ...prev, [name]: files }));
        } 
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formDataCompanyGeneral) {
            if(name == 'crnaLista' || name == 'automatskaBlokada'){
                if(can('ADMINISTRACIJA', 'edit')) {
                    setFormDataCompanyGeneral(prev => ({ ...prev, [name]: value }));
                } else {
                    toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_nemate_prava_za_izmenu_statusa_crne_list'),
                        life: 3000,
                    });
                }
            } else {
                setFormDataCompanyGeneral(prev => ({ ...prev, [name]: value }));
            } 
      
        }
    };

    
     useEffect(()=>{
        if(props.bonitetData) {
            let data = props.bonitetData;

            let Telefon;
            let Email;
            let Web;

            if(data.Kontakt) {
            Telefon = data.Kontakt[0].Telefon;
            Email= data.Kontakt[0].Email;
            Web= data.Kontakt[0].Web;
            }

                setFormDataCompanyGeneral({
                    nazivFirme: data.Naziv_skraceni || '',
                    pib: data.PIB || '',
                    maticniBroj: data.MBR || '',
                    adresa: data.Sediste_ulica || '',
                    adresaPoste: data.adresaPoste || '',
                    grad: data.Sediste_mesto || '',
                    postanskiBroj: data.Sediste_postanski_broj || '',
                    zemlja: data.Sediste_drzava || '',
                    telefon: Telefon,
                    fiksni: data.fiksni || '',
                    emailAdresa: Email,
                    vebStranica: Web,
                    tipPreduzeca: parseInt(data.tipPreduzeca) || '',
                    statusPreduzeca: parseInt(data.statusPreduzeca) || '',
                    crnaLista: data.crnaLista != null ? !!data.crnaLista : null,
                    poreskiObveznik: data.poreskiObveznik != null ? !!data.poreskiObveznik : null,
                    pdvObveznik: data.pdvObveznik != null ? !!data.pdvObveznik : null,
                    automatskaBlokada: data.automatskaBlokada != null ? !!data.automatskaBlokada : null,
                    valuta: data.valuta || null,
                    budzet: data.budzet || '',
                    napomenaBudzet: data.napomenaBudzet || '',
                    napomena: data.napomena || '',
                    dodatnaNapomena: data.dodatnaNapomena || '',
                    ugovorenaPravilaNapomena: data.ugovorenaPravilaNapomena || '',
                });

        if(data.TekuciRacuni) {
                const racuniData = data.TekuciRacuni.map(account => ({
                    tekuciRacun: account.Tekuci_Racun || '',
                    swift: account.swift || '',
                    nazivBanke: account.Banka || '',
                    statusRacuna: account.Status_Racuna == 'Uključen u platni promet' ? 0 : null,
                    tipRacuna: account.Tip_Racuna == 'Dinarski' ? 1 : 2
                }));
            
            // Set the state with the transformed data
            setRacuni(racuniData);
            }

        if(data.Zastupnici) {
                let filteredDir = data.Zastupnici.filter(x=> x.Zastupnik_funkcija == 'Direktor')
                const direktorData = filteredDir.map(dir => ({
                        direktorImePrezime: dir.Zastupnik_ime + ' ' +  dir.Zastupnik_prezime,
                        direktorEmail: '',
                        direktorMobilni: ''
                }));
                setDirektori(direktorData);

                let filteredSar = data.Zastupnici.filter(x=> x.Zastupnik_funkcija != 'Direktor')
                const saradnikData = filteredSar.map(sar => ({
                        saradnikImePrezime: sar.Zastupnik_ime + ' ' +  sar.Zastupnik_prezime,
                        saradnikEmail: '',
                        saradnikMobilni: '',
                        saradnikFunkcija: sar.Zastupnik_funkcija || ''
                }));
                setSaradnici(saradnikData);
            }

            props.setBonitetData(null)
        }
     },[])


   
    const popuniStavke = (apiData) => {

        setButtonDocumentDB({
            uploadedFileGeneral: apiData.ImaDokumentDB[0].uploadedFileGeneral || 0,
            uploadedFileAPR: apiData.ImaDokumentDB[0].uploadedFileAPR || 0,
        })
     
    setFormDataCompanyGeneral({
        nazivFirme: apiData.Client[0].nazivFirme || '',
        pib: apiData.Client[0].pib || '',
        maticniBroj: apiData.Client[0].maticniBroj || '',
        adresa: apiData.Client[0].adresa || '',
        adresaPoste: apiData.Client[0].adresaPoste || '',
        grad: apiData.Client[0].grad || '',
        postanskiBroj: apiData.Client[0].postanskiBroj || '',
        id_drzava: apiData.Client[0].id_drzava || null,
        telefon: apiData.Client[0].telefon || '',
        fiksni: apiData.Client[0].fiksni || '',
        emailAdresa: apiData.Client[0].email || '',
        vebStranica: apiData.Client[0].vebStranica || '',
        tipPreduzeca: parseInt(apiData.Client[0].tipPreduzeca) || '',
        statusPreduzeca: parseInt(apiData.Client[0].statusPreduzeca) || '',
        crnaLista: apiData.Client[0].crnaLista != null ? !!apiData.Client[0].crnaLista : null,
        poreskiObveznik: apiData.Client[0].poreskiObveznik != null ? !!apiData.Client[0].poreskiObveznik : null,
        pdvObveznik: apiData.Client[0].pdvObveznik != null ? !!apiData.Client[0].pdvObveznik : null,
        automatskaBlokada: apiData.Client[0].automatskaBlokada != null ? !!apiData.Client[0].automatskaBlokada : null,
        valuta: apiData.Client[0].valuta || null,
        budzet: apiData.Client[0].budzet || '',
        napomenaBudzet: apiData.Client[0].napomenaBudzet || '',
        napomena: apiData.Client[0].napomena || '',
        dodatnaNapomena: apiData.Client[0].dodatnaNapomena || '',
        ugovorenaPravilaNapomena: apiData.Client[0].ugovorenaPravilaNapomena || '',
    });

    if(apiData.Racuni) {
            const racuniData = apiData.Racuni.map(account => ({
        tekuciRacun: account.tekuciRacun || '',
        swift: account.swift || '',
        nazivBanke: account.nazivBanke || '',
        statusRacuna: account.statusRacuna != null ? parseInt(account.statusRacuna) : null,
        tipRacuna: parseInt(account.tipRacuna) || null
    }));
    
    // Set the state with the transformed data
    setRacuni(racuniData);
    }
    if(apiData.Direktori) { 
              const direktoriData = apiData.Direktori.map(direktor => ({
        direktorImePrezime: direktor.direktorImePrezime || '',
        direktorEmail: direktor.direktorEmail || '',
        direktorMobilni: direktor.direktorMobilni || ''
    }));
    
    // Set the state with the transformed data
    setDirektori(direktoriData);
    }
    if(apiData.Saradnici) { 
              const saradniciData = apiData.Saradnici.map(saradnik => ({
        saradnikImePrezime: saradnik.saradnikImePrezime || '',
        saradnikEmail: saradnik.saradnikEmail || '',
        saradnikMobilni: saradnik.saradnikMobilni || '',
        saradnikFunkcija: saradnik.saradnikFunkcija || ''
    }));
    
    // Set the state with the transformed data
    setSaradnici(saradniciData);
    }

};

    /* Prima klijenta kao argument jer se poziva odmah po izboru u dropdownu —
       React state (idClient) u tom trenutku još nije osvežen. */
    const popuniRedove = async (klijent) => {
        const izabraniKlijent = klijent || idClient;

        if(!izabraniKlijent) {
             toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_izabrali_kompaniju_da_bi_popunili_'),
                        life: 3000,
                    });
        } else {
             setPopuni(true);
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: izabraniKlijent.ID
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/clients/FillInClientData", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                              
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                const preparedData = {
                                    Client: parsedData.ClientDBFill,
                                    Direktori: parsedData.Direktori,
                                    Saradnici: parsedData.Saradnici,
                                    Racuni: parsedData.Racuni,
                                    ImaDokumentDB: parsedData.ImaDokumentDB
                                }

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                popuniStavke(preparedData)
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }
    const handleUploadAndSaveFiles = async (id)=> {
              
                                            const formData = new FormData();
                                            formData.append("id", id);
                                            formData.append("entityType", "klijenti");

                                            Object.entries(formDataCompanyGeneralFILES).forEach(([key, value]) => {
                                                if (value) {
                                                    if (Array.isArray(value)) {
                                                        // Ako je vrednost niz fajlova (npr. uploadedFileGeneral)
                                                        value.forEach(file => {
                                                            formData.append(key, file); // NE koristi [index]!
                                                        });
                                                    } else {
                                                        // Ako je jedan fajl (npr. uploadedFileAPR)
                                                        formData.append(key, value);
                                                    }
                                                }
                                            });

                                       

                                            let requestOptionsFiles = {
                                                method: "POST",
                                                headers: {
                                                Authorization: "Bearer " + auth.token,
                                                },
                                                body: formData
                                            };
       
                                                await fetch(process.env.REACT_APP_BACKEND_URL + "/clients/InsertClientFiles", requestOptionsFiles)
                                                .then(handleErrors)
                                                .then((data) => {
                                                    
                                                    setIdForFiles(false)
                                                    setIzabran(false)
                                                    setPopuni(false)
                                                    resetData()
                                                    resetDataFiles()
                                                    toast.current.show({
                                                    severity: "success",
                                                    summary: data.message,
                                                    life: 3000,
                                                      });

                                                })
                                                .catch((error) => {
                                                error.json().then((errorMessage) => {
                                                    toast.current.show({
                                                    severity: "error",
                                                    summary: "Error",
                                                    detail: errorMessage.message,
                                                    life: 3000,
                                                    });
                                                    console.log(errorMessage);
                                                });
                                            })
                                 
    }
const resetData = ()=> {

        setButtonDocumentDB({
        uploadedFileGeneral: 0,
        uploadedFileAPR: 0
        })

        setFormDataCompanyGeneral({
            nazivFirme: '',
            pib: '',
            maticniBroj: '',
            adresa: '',
            adresaPoste: '',
            grad: '',
            postanskiBroj: '',
            id_drzava: null,
            telefon: '',
            fiksni: '',
            emailAdresa: '',
            vebStranica: '',
            tipPreduzeca: '',
            statusPreduzeca: '',
            crnaLista: null,
            poreskiObveznik: null,
            pdvObveznik: null,
            automatskaBlokada: null,
            valuta: "",
            bodzet: '',
            napomenaBudzet: '',
            napomena: '',
            dodatnaNapomena: '',
            ugovorenaPravilaNapomena:''
    });
        setDirektori([]);

        setSaradnici([]);

        setRacuni([]);
        setNBSPoruka(false)

}
const resetDataFiles=()=>{
     setFormDataCompanyGeneralFILES({
        uploadedFileGeneral: [],
        uploadedFileAPR: null
    });

}


 const handleFormSubmit = (e) => {

                     e.preventDefault(); // bitno da ne submituje bez validacije
                setFormSubmitted(true)
            if (formRef.current && !formRef.current.checkValidity()) {
                formRef.current.reportValidity(); // prikazuje native browser poruke
                return;
            }
    handleUploadAndSave()
 }
        const handleUploadAndSave = () => {
       
            confirmDialog({
            message: "Jel ste sigurni da želite nastaviti sa unosom?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptInsert,
            reject: rejectInsert,
            });
            //FILES

    };

           const handleDeleteClient = () => {
            if(idClient) {
            confirmDialog({
                    message: `Jel ste sigurni da želite pasivizirati klienta ${idClient.Naziv}?`,
                    acceptLabel: "Da",
                    rejectLabel: "Ne",
                    icon: "pi pi-info-circle",
                    acceptClassName: "p-button-danger",
                    accept: acceptDelete,
                    reject: rejectDelete,
                    });
            }
    };
    const acceptInsert = async (e) => {

                

           

              const hasAnyValueGeneralFiles = Object.values(formDataCompanyGeneralFILES).some(value => {
                // Provera za null ili prazan string
                if (value === null || value === '') return false;
                
                // Provera za nevalidan Date
                if (value instanceof Date && isNaN(value.getTime())) return false;
                
                // Specijalna provera za nizove
                if (Array.isArray(value)) {
                    // Vraća true ako niz nije prazan i sadrži bar jedan validan fajl/objekat
                    return value.length > 0 && value.some(item => item !== null && item !== '');
                }
    
                // Provera za obične fajlove/objekte
                return true;
            });
           
            //DATA
                const hasAnyValueGeneral = Object.values(formDataCompanyGeneral).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
            
            if(izabran && popuni){
                 if(hasAnyValueGeneral){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idClient.ID,
                                formDataCompanyGeneral,
                                racuni,
                                saradnici,
                                direktori
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/clients/UpdateClient", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data[0].message && data[0].message != 'Nema izmena u podacima klijenta.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima klijenta.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                                } else {
                                toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesna_izmena_podataka_klijenta'),
                                life: 3000,
                                });
                                }
                                setFormSubmitted(false)
                                setIdForFiles(data.id)
                               
                                setIzabran(null)
                                setPopuni(null)
                                resetData()
                                resetDataFiles()
                                if((idClient.ID) && (hasAnyValueGeneralFiles)) {
                                handleUploadAndSaveFiles(idClient.ID)
                                }
                                setIdClient(null)
                                
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_klijenta_za_unos'),
                        life: 3000,
                    });
                }
           
           
            } else {
                

                if(hasAnyValueGeneral){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                formDataCompanyGeneral,
                                racuni,
                                direktori,
                                saradnici
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/clients/InsertClient", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                                setFormSubmitted(false)
                                resetData()
                                setIdForFiles(data.id)
                                setIzabran(false)
                                setPopuni(false)
                                if((data.id || idForFiles) && (hasAnyValueGeneralFiles)) {
            
                                handleUploadAndSaveFiles(data.id || idForFiles)
                                }

                               toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesan_unos_podataka_klijenta'),
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_klijenta_za_unos'),
                        life: 3000,
                    });
                }
            }

  };
           

   const acceptDelete = async () => {

            
            if(izabran){

                          let requestOptions = {
                            method: "DELETE",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idClient.ID
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/clients/DeleteClient", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                setIdForFiles(null)
                                setIdClient(null)
                                setIzabran(null)
                                setPopuni(null)
                                
                                resetData()
                                resetDataFiles()
                                
                               toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesno_pasiviziranje_podataka_klijenta'),
                                life: 3000,
                                });
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_nije_moguce_obrisati_klijenta_nije_izabr'),
                        life: 3000,
                    });
                }
           

  };
  const rejectInsert = () => {
    console.log("Odbijen unos podataka!");
  };
const rejectDelete = () => {
    console.log("Odbijeno brsanje zasposlenog!");
  };
    const selectIdClientFUNC = (e) => {
    setIdClient(e.value);
    setIzabran(true);
    setPopuni(false)
    };
const popuniRedoveNBS = (company, isFromDB) => {
    
    if(isFromDB) {
     setFormDataCompanyGeneral({
        nazivFirme: company[0].ShortName || '',
        pib: company[0].TaxIdentificationNumber || '',
        maticniBroj: company[0].NationalIdentificationNumber.length == 7 ? '0' + company[0].NationalIdentificationNumber : company[0].NationalIdentificationNumber || '',
        adresa: company[0].Address || '',
        adresaPoste: '',
        grad: company[0].City || '',
        postanskiBroj: company[0].PostalCode || '',
        id_drzava: null,
        telefon: '',
        fiksni: '',
        emailAdresa: '',
        vebStranica: '',
        tipPreduzeca: parseInt(company[0].CompanyTypeID) || '',
        statusPreduzeca: parseInt(company[0].CompanyStatusID) || '',
        crnaLista: null,
        poreskiObveznik: null,
        pdvObveznik: null,
        automatskaBlokada: null,
        valuta: null,
        budzet: '',
        napomenaBudzet: '',
        napomena: '',
        dodatnaNapomena: '',
        ugovorenaPravilaNapomena: ''
    })
    } else {
         setFormDataCompanyGeneral({
        nazivFirme: company.ShortName || '',
        pib: company.TaxIdentificationNumber || '',
        maticniBroj: company.NationalIdentificationNumber.length == 7 ? '0' + company.NationalIdentificationNumber : company.NationalIdentificationNumber || '',
        adresa: company.Address || '',
        adresaPoste: '',
        grad: company.City || '',
        postanskiBroj: company.PostalCode || '',
        id_drzava: null,
        telefon: '',
        fiksni: '',
        emailAdresa: '',
        vebStranica: '',
        tipPreduzeca: parseInt(company.CompanyTypeID) || '',
        statusPreduzeca: parseInt(company.CompanyStatusID) || '',
        crnaLista: null,
        poreskiObveznik: null,
        pdvObveznik: null,
        automatskaBlokada: null,
        valuta: null,
        budzet: '',
        napomenaBudzet: '',
        napomena: '',
        dodatnaNapomena: '',
        ugovorenaPravilaNapomena: ''
    })
    }
   
}

const popuniRedoveRacuniNBS = (accounts) => {
    
    const racuniData = accounts.map(account => ({
        tekuciRacun: account.Account || '',
        swift: '', // Keeping this empty as per your requirement
        nazivBanke: account.BankName || '',
        statusRacuna: account.CompanyAccountStatusID !== undefined ? 
                     parseInt(account.CompanyAccountStatusID) : null,
        tipRacuna: account.CompanyAccountTypeID !== undefined ? 
                  parseInt(account.CompanyAccountTypeID) : null
    }));
    
    // Set the state with the transformed data
    setRacuni(racuniData);
};
const povuciNBSRacune = async () => {
    
    if(pibNBS.length < 9 || pibNBS == null){
         toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_uneli_pib_pib_mora_imati_9_karakte'),
                        life: 3000,
                    });
    } else {
                      let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                pib: parseInt(pibNBS)
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/nbs/AccountByPIB", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.error){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.error,
                                    life: 3000,
                                    });
                                    return
                                }  
                                 if(data.messageWarn){
                                    toast.current.show({
                                    severity: "warn",
                                    summary: t('admin.m_vec_skinuti_racuni_klijenta_sa_servera'),
                                    detail: data.messageWarn,
                                    life: 3000,
                                    });
                                      if(data.accounts){
                                    popuniRedoveRacuniNBS(data.accounts)
                                }
                                } else {
                                    toast.current.show({
                                    severity: "success",
                                    summary: t('admin.m_uspesno_povlacenje_podataka_racuna_iz_nb'),
                                    detail: data.message,
                                    life: 3000,
                                    });
                                   if(data.accounts){
                                    popuniRedoveRacuniNBS(data.accounts)
                                }
                                }
                         
                              //popuniRedoveNBS(data.company)
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
            }
        }
const povuciNBS = async () => {
    if(pibNBS == null) {
          toast.current.show({
                                severity: "warn",
                                summary: t('admin.m_upozorenje_2'),
                                detail: t('admin.m_niste_uneli_pib_pib_mora_imati_9_karakte'),
                                life: 3000,
                            });
                            return
    }
            if(pibNBS.length < 9 || pibNBS == null){
                toast.current.show({
                                severity: "warn",
                                summary: t('admin.m_upozorenje_2'),
                                detail: t('admin.m_niste_uneli_pib_pib_mora_imati_9_karakte'),
                                life: 3000,
                            });
            } else {
                    resetData()
                      let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                pib: parseInt(pibNBS)
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/nbs/CompanyByPIB", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.error){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.error,
                                    life: 3000,
                                    });
                                    return
                                }  
                                if(data.messageWarn){
                                    toast.current.show({
                                    severity: "warn",
                                    summary: t('admin.m_vec_skinut_klijent_sa_servera'),
                                    detail: data.messageWarn,
                                    life: 3000,
                                    });
                                     if(data.company) {
                                    povuciNBSRacune()
                                    popuniRedoveNBS(data.company, true)
                                    setNBSPoruka(true)
                                }
                                } else {
                                    toast.current.show({
                                    severity: "success",
                                    summary: t('admin.m_uspesno_povlacenje_podataka_iz_nbs_a'),
                                    detail: data.message,
                                    life: 3000,
                                    });
                                     if(data.company) {
                                    povuciNBSRacune()
                                    popuniRedoveNBS(data.company, false)
                                    setNBSPoruka(true)
                                }
                                }
                              
                              setPIBNbs(null)
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
    }
}
const handleChangePIB = (e) => {
   
    if(e.target.value.length <= 9){
    setPIBNbs(e.target.value)
    
    }
   
}
const invalidControl = (data) => {
  if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata

  if (data && data != null && !Number(data)) {
    return data.length > 0 ? false : true;
  } else if (data != null && Number(data)) {
    return false;
  }
  return true;
};

    return (
        <div className="p-fluid grid formUnosZap">
            <div className="col-12">
                    <div className="gridHeader klijent-red" style={{marginTop:'1%'}}>
                            <h4>Učitaj iz NBS-a:</h4>
                             <InputText  style={{ width: "10%", marginLeft: "1%" }} id="PIB" name="PIB" value={pibNBS} type="number" placeholder={t('admin.unesiPib')} onChange={handleChangePIB}/>    
                <Button label={t('admin.ucitaj')} className="mt-3 zaposleniShift" onClick={povuciNBS} /> 
                {nbsPoruka ? <p class="infoPoruka">Klijent je povučen iz sistema NBS-a, ali nisu svi popunjeni podaci.</p> : null}   
                </div>
                
                  <div className="gridHeader klijent-red">
                            <h4>Izbor klijenta:</h4>
                                        <CustomDropdown
                        style={{ width: "30.65%" }}
                        id="izborKlijenta"
                        name="izborKlijenta"
                        className="klijent"
                        value={idClient}
                        options={clientsDB || []}
                        optionLabel="Naziv"
                        placeholder={t('admin.naziv')}
                        onChange={(e) => {
                            const izabraniKlijent = e.target.value;
                            setIdClient(izabraniKlijent);
                            setIzabran(!!izabraniKlijent);
                            setPopuni(false);
                            // brisanje izbora vraća formu na prazno stanje
                            if (!izabraniKlijent) { resetData(); resetDataFiles(); }
                            else popuniRedove(izabraniKlijent);   // podaci se učitavaju odmah
                        }}
                    />  
                {izabran && <Button label={t('common.delete')} className="mt-3 zaposleniShift" onClick={handleDeleteClient} />}
                </div>
            </div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <form autoComplete="off" ref={formRef}>
            <Accordion className='klijentiDashboard' multiple activeIndex={[0]}>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.opstiPodaciFirme')}>
                        <div className="col-12 md:col-6">
                <Card>
                    <div className="gridLicni">
                            <div className="col-12 md:col-6">
                                <label htmlFor="nazivFirme">{t('admin.nazivFirme')}:</label>
                                <InputText invalid={invalidControl(formDataCompanyGeneral.nazivFirme)}
                                  required invalidText="Ovo polje je obavezno." id="nazivFirme" name="nazivFirme" value={formDataCompanyGeneral.nazivFirme} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="pib">{t('admin.pib')}:</label>
                                <InputText invalid={invalidControl(formDataCompanyGeneral.pib)}
                                required id="pib" name="pib" value={formDataCompanyGeneral.pib} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="maticniBroj">{t('admin.maticniBroj')}:</label>
                                <InputText
                                id="maticniBroj" name="maticniBroj" value={formDataCompanyGeneral.maticniBroj} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="adresa">{t('admin.adresa')}:</label>
                                <InputText required invalid={invalidControl(formDataCompanyGeneral.adresa)} id="adresa" name="adresa" value={formDataCompanyGeneral.adresa} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="adresaPoste">{t('admin.adresaPoste')}:</label>
                                <InputText id="adresaPoste" name="adresaPoste" value={formDataCompanyGeneral.adresaPoste} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="grad">{t('ture.grad')}:</label>
                                <InputText required id="grad" invalid={invalidControl(formDataCompanyGeneral.grad)}  name="grad" value={formDataCompanyGeneral.grad} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="postanskiBroj">{t('admin.postanskiBroj')}:</label>
                                <InputText required id="postanskiBroj" invalid={invalidControl(formDataCompanyGeneral.postanskiBroj)} name="postanskiBroj" value={formDataCompanyGeneral.postanskiBroj} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="id_drzava">{t('admin.zemlja')}:</label>
                                <CustomDropdown
                                    id="id_drzava"
                                    name="id_drzava"
                                    value={formDataCompanyGeneral.id_drzava}
                                    options={drzaveOptions || []}
                                    onChange={handleChange}
                                    optionLabel="label"
                                    placeholder={t('ture.phZemlju')}
                                    invalid={invalidControl(formDataCompanyGeneral.id_drzava)}
                                />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="telefon">{t('admin.telefon')}:</label>
                                <InputText required id="telefon" name="telefon" invalid={invalidControl(formDataCompanyGeneral.telefon)} value={formDataCompanyGeneral.telefon} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="fiksni">{t('admin.fiksni')}:</label>
                                <InputText required id="fiksni" name="fiksni" invalid={invalidControl(formDataCompanyGeneral.fiksni)} value={formDataCompanyGeneral.fiksni} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="emailAdresa">{t('admin.emailAdresa')}:</label>
                                <InputText required id="emailAdresa" name="emailAdresa" invalid={invalidControl(formDataCompanyGeneral.emailAdresa)} value={formDataCompanyGeneral.emailAdresa} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="vebStranica">{t('admin.vebStranica')}:</label>
                                <InputText id="vebStranica" name="vebStranica" value={formDataCompanyGeneral.vebStranica}  onChange={handleChange} />
                            </div>

                            {/* Dropdowni */}
                            <div className="col-12 md:col-6">
                                <label htmlFor="tipPreduzeca">{t('admin.tipPreduzeca')}:</label>
                                <Dropdown required id="tipPreduzeca" name="tipPreduzeca" value={formDataCompanyGeneral.tipPreduzeca} invalid={invalidControl(formDataCompanyGeneral.tipPreduzeca)} options={tipoviPreduzecaOptions} onChange={handleChange} placeholder={t('magacin.phTip')} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="statusPreduzeca">{t('nova.status')}:</label>
                                <Dropdown required invalid={invalidControl(formDataCompanyGeneral.statusPreduzeca)} id="statusPreduzeca" name="statusPreduzeca" value={formDataCompanyGeneral.statusPreduzeca} options={statusPreduzecaOptions} onChange={handleChange} placeholder={t('nova.phStatus')} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="crnaLista">{t('admin.crnaLista')}:</label>
                                <Dropdown id="crnaLista" name="crnaLista" value={formDataCompanyGeneral.crnaLista} options={booleanOptions} onChange={handleChange} placeholder={t('admin.daNe')} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="poreskiObveznik">{t('admin.poreskiObveznik')}:</label>
                                <Dropdown id="poreskiObveznik" name="poreskiObveznik" value={formDataCompanyGeneral.poreskiObveznik} options={booleanOptions} onChange={handleChange} placeholder={t('admin.daNe')} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="pdvObveznik">{t('admin.pdvObveznik')}:</label>
                                <Dropdown id="pdvObveznik" name="pdvObveznik" value={formDataCompanyGeneral.pdvObveznik} options={booleanOptions} onChange={handleChange} placeholder={t('admin.daNe')} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="automatskaBlokada">{t('admin.automatskaBlokada')}:</label>
                                <Dropdown id="automatskaBlokada" name="automatskaBlokada" value={formDataCompanyGeneral.automatskaBlokada} options={booleanOptions} onChange={handleChange} placeholder={t('admin.daNe')} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="valuta">{t('admin.valutaDani')}:</label>
                                <InputText id="valuta" name="valuta" value={formDataCompanyGeneral.valuta} type='number' onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="docCPC">{t('ture.viseDokumenata')}:</label>
                    {formDataCompanyGeneralFILES.uploadedFileGeneral.length === 0 ? (
                                <FileUpload
                                    name="uploadedFileGeneral"
                                    className={buttonDocumentDB.uploadedFileGeneral && classDocumentDB}
                                    chooseLabel={buttonDocumentDB.uploadedFileGeneral ? "Fajl u bazi!" : "Izaberi"}
                                    customUpload={false}
                                    multiple
                                    auto={false}
                                    uploadLabel="Pošalji"
                                    mode="basic"
                                    accept=".pdf,.jpg,.png"
                                    maxFileSize={5000000}
                                    onSelect={(e) => handleChangeDocUpload("uploadedFileGeneral", e.files)}
                                />
                            ) : (
                                <div>
                                    {formDataCompanyGeneralFILES.uploadedFileGeneral.map((file, index) => (
                                        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                                            <span style={{ marginRight: '1%', flexGrow: 1 }}>{file.name}</span>
                                            <Button 
                                                icon="pi pi-times" 
                                                className="p-button-rounded p-button-danger p-button-text"
                                                onClick={() => {
                                                    const updatedFiles = [...formDataCompanyGeneralFILES.uploadedFileGeneral];
                                                    updatedFiles.splice(index, 1);
                                                    setFormDataCompanyGeneralFILES(prev => ({
                                                        ...prev,
                                                        uploadedFileGeneral: updatedFiles
                                                    }));
                                                }}
                                                tooltip="Ukloni fajl"
                                                tooltipOptions={{ position: 'top' }}
                                            />
                                        </div>
                                    ))}
                                    
                                    <Button 
                                        label={t('ture.obrisiSve')} 
                                        onClick={() => setFormDataCompanyGeneralFILES(prev => ({
                                            ...prev,
                                            uploadedFileGeneral: []
                                        }))} 
                                        className="p-button-text p-button-danger"
                                        style={{ marginTop: '1rem' }}
                                    />
                                </div>
                            )}
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="docCPC">{t('admin.apr')}:</label>
                         {!formDataCompanyGeneralFILES.uploadedFileAPR ? <FileUpload
                                className={buttonDocumentDB.uploadedFileAPR && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileAPR ? "Fajl u bazi!" : "Izaberi"}
                                name="uploadedFileAPR"
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileAPR", e.files[0])}
                                />: <Button label={formDataCompanyGeneralFILES.uploadedFileAPR.name} onClick={() => handleChangeDocUpload("uploadedFileAPR", null)} />}
                            </div>
                       
                        </div>
                        
                </Card>
            </div>
                </AccordionTab>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.odgovornaLica')}>
                  <div className="col-12 md:col-6">
                <Card>
                    <div className="gridDokumenti">
                        <div className="red1 redDokument" style={{alignItems: "center", maxWidth: '100%'}}> 
                           <div className="col-12">
                                <h4 style={{width: 'fitcontent'}}>Direktori:</h4>
                            </div>
                            <div className="redMiddle">
                            {direktori.map((direktor, index) => (
                                <div key={index} className="red1 odgovornaLica">
                                <div className="col-12 md:col-6">
                                    <label htmlFor={`direktorImePrezime-${index}`}>{t('admin.imePrezime')}:</label>
                                    <InputText
                                    id={`direktorImePrezime-${index}`}
                                    value={direktor.direktorImePrezime}
                                    onChange={(e) => handleDirektorChange(index, 'direktorImePrezime', e.target.value)}
                                    />
                                </div>

                                <div className="col-12 md:col-6">
                                    <label htmlFor={`direktorEmail-${index}`}>{t('login.email')}:</label>
                                    <InputText
                                    id={`direktorEmail-${index}`}
                                    value={direktor.direktorEmail}
                                    onChange={(e) => handleDirektorChange(index, 'direktorEmail', e.target.value)}
                                    />
                                </div>

                                <div className="col-12 md:col-6">
                                    <label htmlFor={`direktorMobilni-${index}`}>{t('admin.mobilni')}:</label>
                                    <InputText
                                    id={`direktorMobilni-${index}`}
                                    value={direktor.direktorMobilni}
                                    onChange={(e) => handleDirektorChange(index, 'direktorMobilni', e.target.value)}
                                    />
                                </div>

                                <div className="col-12 md:col-6 flex align-items-end minusButtonODG">
                                    <Button
                                    icon="pi pi-minus"
                                    className="p-button-danger"
                                    onClick={() => removeDirektor(index)}
                                    disabled={direktori.length === 0}
                                    />
                                </div>
                                </div>
                            ))}
                            </div>
                            <div className="col-12" style={{marginTop: "0"}}>
                                <Button icon="pi pi-plus" type="button" label={t('admin.dodajDirektora')} onClick={addDirektor} className="p-button-success" />
                            </div>
                        </div>
                       <div className="red2 redDokument" style={{alignItems: "center"}}> 
                         <div className="col-12">
                            <h4>Saradnici:</h4>
                        </div>
                        <div className="redMiddle"> {saradnici.map((saradnik, index) => (
                            <div key={index} className="red1 odgovornaLica">
                            <div className="col-12 md:col-6">
                                <label htmlFor={`saradnikImePrezime-${index}`}>{t('admin.imePrezime')}:</label>
                                <InputText
                                id={`saradnikImePrezime-${index}`}
                                value={saradnik.saradnikImePrezime}
                                onChange={(e) => handleSaradnikChange(index, 'saradnikImePrezime', e.target.value)}
                                />
                            </div>

                            <div className="col-12 md:col-6">
                                <label htmlFor={`saradnikEmail-${index}`}>{t('login.email')}:</label>
                                <InputText
                                id={`saradnikEmail-${index}`}
                                value={saradnik.saradnikEmail}
                                onChange={(e) => handleSaradnikChange(index, 'saradnikEmail', e.target.value)}
                                />
                            </div>

                            <div className="col-12 md:col-6">
                                <label htmlFor={`saradnikMobilni-${index}`}>{t('admin.mobilni')}:</label>
                                <InputText
                                id={`saradnikMobilni-${index}`}
                                value={saradnik.saradnikMobilni}
                                onChange={(e) => handleSaradnikChange(index, 'saradnikMobilni', e.target.value)}
                                />
                            </div>

                            <div className="col-12 md:col-6">
                                <label htmlFor={`saradnikFunkcija-${index}`}>{t('admin.funkcija')}:</label>
                                <InputText
                                id={`saradnikFunkcija-${index}`}
                                value={saradnik.saradnikFunkcija}
                                onChange={(e) => handleSaradnikChange(index, 'saradnikFunkcija', e.target.value)}
                                />
                            </div>

                            <div className="col-12 md:col-6 flex align-items-end minusButtonODG">
                                <Button
                                icon="pi pi-minus"
                                className="p-button-danger"
                                onClick={() => removeSaradnik(index)}
                                disabled={saradnici.length === 0}
                                />
                            </div>
                            </div>
                        ))}</div>
                       

                        <div className="col-12" style={{marginTop: "0"}}>
                            <Button icon="pi pi-plus" label={t('admin.dodajSaradnika')} onClick={addSaradnik} type="button" className="p-button-success" />
                        </div>
                        </div>
                    
                    </div>
                </Card>
            </div>
                </AccordionTab>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.racuniCaps')}>
                    <div className="col-12 md:col-6">
                <Card>
                    <div className="gridDokumentiRacuni">
                        <div className="red1 redDokument" style={{alignItems: "center", justifyContent: 'space-between'}}> 
                                <div className="col-12" style={{maxWidth: 'fit-content !important'}}>
                                        <h4 style={{maxWidth: 'fit-content !important'}}>{t('admin.tekuciRacuni')}:</h4>
                                    </div>
                                    <div className="redMiddleRacuni">
                                    {racuni.map((racun, index) => (
                                        <div key={index} className="red1 odgovornaLica" style={{maxWidth:'fit-content'}}>
                                        <div className="col-12 md:col-6">
                                            <label htmlFor={`tekuciRacun-${index}`}>{t('nova.tekuciRacun')}:</label>
                                            <InputText
                                            id={`tekuciRacun-${index}`}
                                            value={racun.tekuciRacun}
                                            required
                                            invalid={invalidControl(racun.tekuciRacun)}
                                            onChange={(e) => handleRacunChange(index, 'tekuciRacun', e.target.value)}
                                            />
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <label htmlFor={`swift-${index}`}>{t('admin.swift')}:</label>
                                            <InputText
                                            id={`swift-${index}`}
                                            value={racun.swift}
                                            onChange={(e) => handleRacunChange(index, 'swift', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-6">
                                            <label htmlFor={`nazivBanke-${index}`}>{t('admin.nazivBanke')}:</label>
                                            <InputText
                                            id={`nazivBanke-${index}`}
                                            required
                                            invalid={invalidControl(racun.nazivBanke)}
                                            value={racun.nazivBanke}
                                            onChange={(e) => handleRacunChange(index, 'nazivBanke', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-6">
                                            <label htmlFor={`tipRacuna-${index}`}>{t('admin.tipRacuna')}:</label>
                                            <Dropdown id={`tipRacuna-${index}`} name="tipRacuna" required invalid={invalidControl(racun.tipRacuna)} value={racun.tipRacuna} options={tipoviRacunaOptions} onChange={(e) => handleRacunChange(index, 'tipRacuna', e.target.value)}/>
                                        </div>
                                        <div className="col-12 md:col-6">
                                            <label htmlFor={`statusRacuna-${index}`}>{t('admin.statusRacuna')}:</label>
                                            <Dropdown id={`statusRacuna-${index}`} required name="statusRacuna"  invalid={invalidControl(racun.statusRacuna)} value={racun.statusRacuna} options={statusRacunaOptions} onChange={(e) => handleRacunChange(index, 'statusRacuna', e.target.value)}/>   
                                        </div>
                                        <div className="col-12 md:col-6 flex align-items-end minusButtonODG">
                                            <Button
                                            icon="pi pi-minus"
                                            className="p-button-danger"
                                            onClick={() => removeRacun(index)}
                                            disabled={racuni.length === 0}
                                            />
                                        </div>
                                        </div>
                                    ))}
                                    </div>
                                    <div className="col-12" style={{marginTop: "0", marginLeft: "1%"}}>
                                        <Button icon="pi pi-plus" label={t('admin.dodajRacun')} onClick={addRacun} type="button" className="p-button-success" />
                                    </div>
                                </div>
                          <div className="red2 redDokument" style={{alignItems: "center"}}> 
                            <div className="col-12">
                                <h4>{t('admin.budzet')}:</h4>
                            </div>
                            <div className="col-12 md:col-6" style={{maxWidth: '20%'}}>
                                <label htmlFor="budzet">{t('admin.budzet')}:</label>
                                <InputText id="budzet" name="budzet" value={formDataCompanyGeneral.budzet} onChange={handleChange} />
                            </div>
                            <div style={{marginLeft: '2%', marginRight: '0', flex: '0 0 60%', maxWidth: '100%'}} className="col-12 md:col-6">
                                <label htmlFor="budzet">{t('admin.napomenaBudzet')}:</label>
                                <InputTextarea variant="filled" name="napomenaBudzet" value={formDataCompanyGeneral.napomenaBudzet} onChange={handleChange} rows={5} cols={30} />
                            </div>
                           
                            </div>    
                    </div>
                </Card>
            </div>
                </AccordionTab>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.napomeneCaps')}>
                   <div className="col-12 md:col-6">
                <Card>
                    <div className="gridTextArea">
                        <div className="col-12 md:col-6">
                                <label htmlFor="grad">{t('nova.napomena')}:</label>
                                <InputTextarea variant="filled" name="napomena" value={formDataCompanyGeneral.napomena} onChange={handleChange} rows={5} cols={30} />
                            </div>
                             <div className="col-12 md:col-6">
                                <label htmlFor="grad">{t('admin.dodatnaNapomena')}:</label>
                                <InputTextarea variant="filled" name="dodatnaNapomena" value={formDataCompanyGeneral.dodatnaNapomena} onChange={handleChange} rows={5} cols={30} />
                            </div>
                             <div className="col-12 md:col-6">
                                <label htmlFor="grad">{t('admin.ugovorenPosao')}:</label>
                                <InputTextarea variant="filled" name="ugovorenaPravilaNapomena" value={formDataCompanyGeneral.ugovorenaPravilaNapomena} onChange={handleChange} rows={5} cols={30} />
                            </div> 
                    </div>
                </Card>
            </div>
                </AccordionTab>
              
            </Accordion>
           
            
           <div className="formUnosZap buttonUnosZap">
              <button
                type="submit"
                onClick={handleFormSubmit}
                className="btn btn-success"
              >
                {izabran ? 'SAČUVAJ' : 'UNOS' }
              </button>
            </div>
            </form>
        </div>
    );
};

export default KlijentiUnos;